//import { testService } from '@/_services'

const testuser = JSON.parse(localStorage.getItem('testuser')) || null;

export const tests = {
  namespaced: true,
  state: {
    testuser
  },
  getters: {
    
  },
  mutations: {
    setTestuser(state, user) {
      state.testuser = user;
      //localStorage.setItem('testuser', JSON.stringify(user))
    }
  },
  actions: {
    
  }
}